import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  INTERNAL_SERVICE_ROLES,
  type InternalServiceRole,
  type InternalServiceRoleHolder
} from '@percent/admin-dashboard/api/actions/internalServices/internalServices.types'

/** The service's only owner, whom the API refuses to move or remove; a hint, as the API decides. */
export const isLastOwner = (holders: InternalServiceRoleHolder[], holder: InternalServiceRoleHolder) =>
  holder.role === 'owner' && holders.filter(({ role }) => role === 'owner').length === 1

/** A holder's name, or its id for one that can no longer be named. */
export const holderLabel = ({ holderName, holderId }: InternalServiceRoleHolder) => holderName ?? holderId

/** Each role's label, and the roles as select options - the same objects every render, as a select's value. */
export function useServiceRoleLabels() {
  const { t } = useTranslation()

  return useMemo(() => {
    const labelOf = (role: InternalServiceRole) => t(`serviceDetail.roles.role.${role}`)

    return { labelOf, options: INTERNAL_SERVICE_ROLES.map(role => ({ value: role, label: labelOf(role) })) }
  }, [t])
}
